module.exports = __webpack_public_path__ + "static/media/time-auth.d7444890.svg";